var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.enableAddNew)?_c('div',{staticClass:"add-new",on:{"click":_vm.handleClick}},[_vm._v("\n  "+_vm._s(_vm.message || _vm.$t('components.searchEngine.addNew'))+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }